// extracted by mini-css-extract-plugin
export default {"coll":"index_coll__ZqPTc"};